export type OptionTransformType<T> = {
  options: T[]
  label?: keyof T | 'label' | ((option: T) => string)
  value?: keyof T | 'key'
  returnOption?: boolean
}

export const transformOptions = <T>({
  options,
  label = 'label',
  value = 'key',
  returnOption
}: OptionTransformType<T>) =>
  options?.map?.((option) => {
    const labelValue =
      typeof label === 'function' ? label(option) : option?.[label as keyof T]
    const valueValue = option?.[value as keyof T]

    return {
      label: labelValue ?? option?.[value as keyof T] ?? option,
      value: valueValue ?? option,
      ...(returnOption && option)
    }
  })

export const getMultipleParamsValues = (
  param?: string | number | (string | number)[] | readonly (string | number)[]
): number[] | undefined => {
  if (!param) return undefined

  const raw = Array.isArray(param) ? param.join(',') : String(param)

  const numbers = raw
    .split(',')
    .map((s) => Number(s.trim()))
    .filter((n) => !isNaN(n) && isFinite(n))

  return numbers.length > 0 ? numbers : undefined
}
